import React from 'react';
import Modal from './Modal';

function SideSelector({ isOpen, onClose, onSelect, surgeryType }) {

  const handleSideSelect = (side) => {
    onSelect(surgeryType, side);
    onClose();
  };

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      title="Choose a Side"
    >
      <div className="side-options">
        <button
          className="side-option-button"
          onClick={() => handleSideSelect('left')}
        >
          Left Side
        </button>
        <button
          className="side-option-button"
          onClick={() => handleSideSelect('right')}
        >
          Right Side
        </button>
        <button
          className="side-option-button"
          onClick={() => handleSideSelect('bilateral')}
        >
          Bilateral
        </button>
      </div>
    </Modal>
  );
}

export default SideSelector; 